import Header3 from 'elements/Header3';
import ds, { media } from 'designsystem';

const PersonName = Header3.extend`
  overflow: visible;
  margin-top: 0;
  margin-bottom: ${ds.get('metrics.s')};
  font-size: ${ds.fs('m')};
  line-height: ${ds.get('type.lineHeight.s')};
    
  ${media.tablet`
    font-size: ${ds.fs('m')};
    line-height: ${ds.get('type.lineHeight.s')};
  `}
  
   ${media.desktop`
    font-size: ${ds.fs('l')};
    line-height: ${ds.get('type.lineHeight.l')};
  `}
`;

export default PersonName;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/PersonName.jsx